module.exports = __webpack_public_path__ + "static/lageplan2-f273d985455fdefb1e623fa65c5ca788.png";